/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("TextFormat4STBehavior", ["StyleBehaviorBase"], function (context, cls) {
  /**
   * @class TextFormat4STBehavior
   * @memberOf classes
   * @extends classes.StyleBehaviorBase
   */
  cls.TextFormat4STBehavior = context.oo.Singleton(cls.StyleBehaviorBase, function ($super) {
    return /** @lends classes.TextFormat4STBehavior.prototype */ {
      __name: "TextFormat4STBehavior",

      usedStyleAttributes: ["textFormat"],
      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const widget = controller.getWidget();
        const format = controller.getAnchorNode().getStyleAttribute("textFormat");
        if (widget?.setHtmlFormat) {
          widget.setHtmlFormat(format === "html");
          return;
        }

        if (format !== "html") {
          return;
        }
        let dialogType = controller.getAnchorNode().attribute("dialogType");
        if (controller.isInTable()) {
          // Handle input array dialog type.
          dialogType = controller.getAnchorNode().getTableNode().attribute("dialogType");
        }
        const dialogTypeIsInput = dialogType === "Input" || dialogType === "InputArray";
        if (controller._widgetType === "TextEdit" && controller.setAsRichText && dialogTypeIsInput) {
          controller.setAsRichText(true); //return true to invalidate following behaviors
        } else {
          const control = document.createElement("div");
          control.classList.add("textEditHtml");
          widget.setHtmlControl(control);
        }
      }
    };
  });
});
